// extracted by mini-css-extract-plugin
module.exports = {"confirm":"SettingPaymentDate__confirm--3caYI","icon":"SettingPaymentDate__icon--1iKq0","check":"SettingPaymentDate__check--36CQT"};